import { RESET_STUDIO_ACTION } from '../consts';
import type { StudioLocaleActions } from '../../actions/studio/locale';
import { HYDRATE_STATE } from '../../store/consts';
import type { SchemaLocale } from '../../types/Schema';

export interface State {
    locales: SchemaLocale[];
    allLocales: string[];
    filteredLocales: string[];
    allowedLocales: Array<string | null>;
    selectedLocale: string | null;
}

const getDefaultState = (): State => ({
    locales: [],
    allLocales: [],
    filteredLocales: [],
    allowedLocales: [null],
    selectedLocale: null
});

const localeReducer = (state = getDefaultState(), action: StudioLocaleActions | null): State => {
    switch (action?.type) {
        case HYDRATE_STATE: {
            return {
                ...getDefaultState(),
                ...(action?.data.studio?.locale ?? {})
            };
        }

        case 'SET_LOCALES': {
            const { locales, allLocales } = action.data || {};

            return {
                ...state,
                locales,
                allLocales
            };
        }

        case 'SET_SELECTED_LOCALE': {
            const { selectedLocale } = action.data || {};

            return {
                ...state,
                selectedLocale: selectedLocale
            };
        }

        case 'SET_ALLOWED_LOCALES': {
            const { allowedLocales } = action.data || {};

            return {
                ...state,
                allowedLocales
            };
        }

        case 'SET_FILTERED_LOCALES': {
            const { filteredLocales } = action.data || {};
            return {
                ...state,
                filteredLocales
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export const localStorePaths = ['locale.selectedLocale'];

export default localeReducer;
